import {
  ExtranetNewsletterDto,
  GetExtranetNewslettersQueryDto,
} from '@pharmac-extranet/extranet-api'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { getNewslettersQuery } from './newsletter.queries'

export const useNewsletters = (params?: GetExtranetNewslettersQueryDto) => {
  const {
    data,
    isLoading: newslettersIsLoading,
    isFetching,
  } = useQuery(getNewslettersQuery(params))

  const [newsletters, setNewsletters] = useState<ExtranetNewsletterDto[]>([])

  useEffect(() => {
    if (data && data.data && !newslettersIsLoading) {
      setNewsletters(data.data)
    }
  }, [data, newslettersIsLoading, isFetching])

  return {
    newsletters,
    newslettersIsLoading,
  }
}
